// @flow
import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import notFoundImg from "~/assets/images/svg/file-searching.svg";
import PageTitle from "~/components/PageTitle";

const ErrorPageNotFound = ({ withPageTitle }) => {
  return (
    <React.Fragment>
      {withPageTitle && (
        <PageTitle
          breadCrumbItems={[
            { label: "Pages", path: "/pages/error-404" },
            { label: "404", path: "/pages/error-404", active: true },
          ]}
          title={"404 Error"}
        />
      )}

      {!withPageTitle && <Helmet title="Halaman Tidak Ditemukan" />}

      <Row
        className="justify-content-center"
        style={{ paddingTop: !withPageTitle ? "90px" : "0" }}
      >
        <Col lg={4}>
          <div className="text-center">
            <img src={notFoundImg} height="90" alt="" />
            <h1 className="text-error mt-4">404</h1>
            <h4 className="text-uppercase text-danger mt-3">
              Halaman Tidak Ditemukan
            </h4>
            <p className="text-muted mt-3">
              Sepertinya Anda salah belok. Jangan khawatir ... itu terjadi pada
              yang terbaik kami. Berikut sedikit tip yang mungkin membantu Anda
              kembali ke jalur semula.
            </p>

            <Link className="btn btn-primary mt-3" to="/">
              <i className="mdi mdi-reply"></i> Kembali ke Dashboard
            </Link>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

ErrorPageNotFound.defaultProps = {
  withPageTitle: true,
};

ErrorPageNotFound.propTypes = {
  withPageTitle: PropTypes.bool,
};

export default ErrorPageNotFound;
